import { jsx as l } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M32.003 32c7.18 0 13-5.82 13-13s-5.82-13-13-13-13 5.82-13 13 5.82 13 13 13Zm0-22c4.963 0 9 4.037 9 9 0 4.962-4.037 9-9 9-4.962 0-9-4.038-9-9 0-4.963 4.038-9 9-9Zm22 44 1.072 4H10.002c-2.209 0-4-1.797-4-4.012V40.39l26-6.891 7.644 2.026-7.601 2.123-.043-.011-22 5.831v10.528l.004.003h43.996Zm4-12.505v11.433l-1.847.495-1.654-8.923 3.501-3.005ZM46.31 34.303l1.98 3.468.408.714.79.22 4.241 1.187-2.706 2.322-.875.75.21 1.132.72 3.877-3.937-1.798-.831-.38-.831.38-3.936 1.798.718-3.877.21-1.132-.873-.75-2.707-2.324 4.24-1.184.79-.221.408-.714 1.98-3.468Zm0-4.034-3.718 6.51-7.843 2.192 5.546 4.76-1.42 7.66 7.435-3.397 7.435 3.397-1.42-7.66 5.546-4.758-7.843-2.193-3.718-6.511Z"
      }
    )
  }
);
export {
  t as CustomerStar
};
